<template>
  <div class="container1">
    <head-page></head-page>
    <payment-result isPayFail></payment-result>
    <footer-page></footer-page>
  </div>
</template>

<script>
import HeadPage from "@/components/HeadPage.vue";
import PaymentResult from "@/components/PaymentResult.vue";
import FooterPage from "@/components/FooterPage.vue";
export default {
  name: "PaymentFailure",
  components: {
    HeadPage,
    PaymentResult,
    FooterPage,
  },
};
</script>

<style lang="scss" scoped></style>
